import QuantitySelectView from 'package-quantity-select.view';
import * as React from 'react';
import { connect } from 'react-redux';
import { IPriceType } from '../../custom/classes/production';
import { IPackageListingAppState } from '../../redux-state';
import { updatePriceTypeQuantity, clearPriceTypeQuantities } from '../../redux-state/actions/package-listing.actions';
import { flatMap, uniqBy } from 'lodash';


interface StateToProps {
    packagePriceTypes: Array<IPriceType>;
    selectedPriceTypeQuantities: Map<number, number>;
    selectTicketsText: string;
    selectPackageTitle: string;
    isUnseatedReservation: boolean;
    isVoucherPackage: boolean;
    cartItems: Map<number, number>;
}

interface DispatchToProps {
    selectPriceTypeQuantity: (priceTypeId, quantity) => void;
    resetPriceTypeQuantities: () => void;
}

export type QuantitySelectProps = StateToProps & DispatchToProps;


export class QuantitySelectBase extends React.Component<QuantitySelectProps, any> {
    constructor(props: QuantitySelectProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.selectPriceTypeQuantity.length == 0) {
            // reset state again because of browser state being loaded and react not knowing how to handle it
            setTimeout(() => this.props.resetPriceTypeQuantities());
        }
    }

    render() {
        return <QuantitySelectView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState): StateToProps {
    return {
        packagePriceTypes: state.packageListingSettings.isFixed ?
            uniqBy(flatMap(state.packageListing.packages.map(p => p.packagePriceTypes)), pt => pt.priceTypeId)
            : uniqBy(state.packageListing.packageDetail.packagePriceTypes, pt => pt.priceTypeId),
        selectTicketsText: state.packageListingText.selectTicketsTitle,
        selectPackageTitle: state.packageListingText.selectPackageTitle,
        selectedPriceTypeQuantities: state.packageListing.priceTypeQuantity,
        isUnseatedReservation: state.packageListingSettings.useUnseatedReservation,
        isVoucherPackage: state.packageListingSettings.voucherPackage,
        cartItems: state.packageListing.cartItems,
    }
}

function mapDispatchToProps(dispatch, ownProps: QuantitySelectProps): DispatchToProps {
    return {
        selectPriceTypeQuantity: (ptId, quantity) => {
            dispatch(updatePriceTypeQuantity(ptId, quantity));
        },
        resetPriceTypeQuantities: () => {
            dispatch(clearPriceTypeQuantities());
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(QuantitySelectBase);